<template>
    <div class="home">
      <HeaderComponent></HeaderComponent>
      <ContactComponent></ContactComponent>
      <FooterComponent></FooterComponent>
    </div>
  </template>

<script>
import HeaderComponent from '@/components/header/header.vue'
import FooterComponent from '@/components/footer/footer.vue'
import ContactComponent from '@/components/contact/contact.vue'

export default {
  name: 'ContactView',
  components: {
    HeaderComponent,
    ContactComponent,
    FooterComponent
  }
}
</script>
